﻿import { global } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import { ObdobjefilterValues } from "../Components/saop-select-month-year";

export enum SaopRightSidebarView {
    Dashboard = 0
    ,Absence = 1
    ,AttendanceDay = 2
    ,AttendanceMonth = 3    
    ,TravelOrders = 4
    , InternalOrders = 5
    , AbsenceCalendar = 6
}

export class SaopRightSidebar {
    private _saopServicesCore: SaopServicesCore;
    private _saopServicesCoreAlternative: SaopServicesCore;

    constructor() {
        this._saopServicesCore = new SaopServicesCore();
        this._saopServicesCoreAlternative = new SaopServicesCore();
    }


    bindCarouselDiv(contentId:string,view:SaopRightSidebarView){
        global.ConsoleLogDegug("SaopRightSidebar.bindDiv"); 
        this._saopServicesCore.afterDone = function(response){
            $(contentId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action:"RightSideBar/GetCarouselView?view="+view.toString()
            ,data:null
            ,type:"GET"
            ,spinnerDivId:"#saopLoadingSidebarr"
            ,async:false
        });           
    }

    refreshDopustZaKoriscenjeSummary(contentId: string, spinnerDivId: string = "#saopLoadingSidebarr"): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshDopustZaKoriscenjeSummary");

        this._saopServicesCore.afterDone = function(response){
            $(contentId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action:"RightSideBar/DopustZaKoriscenjeSummaryPartial"
            ,data:null
            ,type:"GET"
            ,spinnerDivId: spinnerDivId
        });        
    }


    refreshUreZaKoriscenjeSummary(contentId: string, spinnerDivId: string = "#saopLoadingSidebarr"): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshUreZaKoriscenjeSummary");

        this._saopServicesCore.afterDone = function(response){
            $(contentId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action:"RightSideBar/UreZaKoriscenjeSummaryPartial"
            ,data:null
            ,type:"GET"
            ,spinnerDivId: spinnerDivId
        });
    }

    refreshOdsotnostiEmployeeSummary(sifraZapolseni: string, contentDopustId: string, contentUreId: string, spinnerDivId: string = "#saopLoadingSidebarr"): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshOdsotnostiEmployeeSummary");

        this._saopServicesCore.afterDone = function (response) {
            $(contentDopustId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action: "RightSideBar/DopustZaKoriscenjeEmployeeSummaryPartial"
            , data: {
                sifraZapolseni: sifraZapolseni
            }
            , type: "GET"
            , spinnerDivId: spinnerDivId
        });

        this._saopServicesCoreAlternative.afterDone = function (response) {
            $(contentUreId).html(response);
        };
        this._saopServicesCoreAlternative.ExecuteAction({
            action: "RightSideBar/UreZaKoriscenjeEmployeeSummaryPartial"
            , data: {
                sifraZapolseni: sifraZapolseni
            }
            , type: "GET"
            , spinnerDivId: spinnerDivId
        });
    }

    refreshOdsotnostiSummary(contentDopustId: string, contentUreId: string, spinnerDivId: string = "#saopLoadingSidebarr"): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshOdsotnostiSummary");

        this._saopServicesCore.afterDone = function (response) {
            $(contentDopustId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action: "RightSideBar/DopustZaKoriscenjeSummaryPartial"
            , type: "GET"
            , spinnerDivId: spinnerDivId
        });

        this._saopServicesCoreAlternative.afterDone = function (response) {
            $(contentUreId).html(response);
        };
        this._saopServicesCoreAlternative.ExecuteAction({
            action: "RightSideBar/UreZaKoriscenjeSummaryPartial"
            , type: "GET"
            , spinnerDivId: spinnerDivId
        });
    }


    refreshRegUraDogodkiSummary(contentId: string, selectedMonthYear: ObdobjefilterValues, spinnerDivId:string): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshRegUraDogodkiSummary");

        let _this = this;
        let params = { leto: selectedMonthYear.leto, mesec: selectedMonthYear.mesec };

        this._saopServicesCore.afterDone = function(response){
            $(contentId).html(response);
            _this.setHeight();
            window.onresize = function () {
                _this.setHeight();
            };
        };
        this._saopServicesCore.ExecuteAction({
            action:"RightSideBar/RegUraDogodkiSummaryPartial"
            ,data:params
            ,type:"GET"
            ,spinnerDivId:spinnerDivId
            //,spinnerDivId:"#saopLoadingSidebarr"
        });
    }

    refreshRegOPNPotniNalogiSummary(contentId: string, spinnerDivId:string): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshRegOPNPotniNalogiSummary");

        this._saopServicesCore.afterDone = function(response){
            $(contentId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action:"TravelOrder/TravelOrdersSummary"
            ,data:null
            ,type:"GET"
            ,spinnerDivId:spinnerDivId
            //,spinnerDivId:"#saopLoadingSidebarr"
        });
    }

    refreshNdkInternalOrdersSummary(contentId: string, spinnerDivId: string): void {
        global.ConsoleLogDegug("SaopRightSidebar.refreshNdkInternalOrdersSummary");

        this._saopServicesCore.afterDone = function (response) {
            $(contentId).html(response);
        };
        this._saopServicesCore.ExecuteAction({
            action: "RightSideBar/InternalOrdersSummary"
            , data: null
            , type: "GET"
            , spinnerDivId: spinnerDivId
            //,spinnerDivId:"#saopLoadingSidebarr"
        });
    }

    setHeight() {
        var header = $("#site-header").height();
        var footer = $("#site-footer").height();
        $("#reg-summary-container").height(window.innerHeight - header - footer - 106);
    }


    //
}




